import { Form } from 'antd';
import { IMaskInput } from 'react-imask';

function CustomerPhoneInputFormatted({
  className,
  name,
  label,
  errorMessage,
  rules = [],
  disabled = false,
  noMask = false,
}) {
  const mask = [{ mask: '000 00 00 00' }];

  return (
    <Form.Item
      rules={rules}
      className={`customer-input ${className}`}
      name={name}
      label={label}
      help={errorMessage}
      validateStatus={errorMessage && 'error'}
    >
      {noMask
        ? (
          <input
            type="text"
            name={name}
            className={`w-full focus:outline-none bg-white ${
              disabled ? '!text-[#00000040] !cursor-not-allowed' : ''
            }`}
            disabled={disabled}
          />
        )
        : (
          <IMaskInput
            mask={mask}
            name={name}
            className={`w-full focus:outline-none bg-white ${
              disabled ? '!text-[#00000040] !cursor-not-allowed' : ''
            }`}
            disabled={disabled}
          />
        )}
    </Form.Item>
  );
}

export default CustomerPhoneInputFormatted;
